import React, { useState } from 'react';
import axios from 'axios';

const RecipeAdjustmentForm = ({ recipeId, api }) => {
  const [adjustedDate, setAdjustedDate] = useState('');
  const [adjustmentNote, setAdjustmentNote] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const handleSubmitAdjustment = async (event) => {
    event.preventDefault();
    setUploading(true);
    setUploadError('');
    setUploadSuccess('');

    if (!selectedImage) {
      setUploadError('画像を添付してください。');
      setUploading(false);
      return;
    }

    try {
      // 1. 画像をS3にアップロードするための署名付きURLを取得
      const s3PresignedUrlResponse = await api.post(`/upload-image`, {
        fileName: selectedImage.name,
        fileType: selectedImage.type,
      });
      const { uploadUrl, filePath } = s3PresignedUrlResponse.data;

      // 2. 署名付きURLを使用してS3に画像をアップロード
      await axios.put(uploadUrl, selectedImage, { // S3へのアップロードはaxiosインスタンスではなく通常のaxiosを使用
        headers: {
          'Content-Type': selectedImage.type,
        },
      });

      // 3. 調整記録をAPIに送信
      await api.post(`/recipes/${recipeId}/adjustments`, {
        recipe_id: recipeId,
        adjusted_date: adjustedDate,
        note: adjustmentNote,
        image_path: filePath,
      });

      setUploadSuccess('調整記録が正常に保存されました！');
      setAdjustedDate('');
      setAdjustmentNote('');
      setSelectedImage(null);
      // フォームをリセットするためにファイル入力もリセット
      document.getElementById('adjustmentImage').value = '';

    } catch (err) {
      console.error('調整記録の保存エラー:', err);
      setUploadError('調整記録の保存中にエラーが発生しました。');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
      <h2 style={{ textAlign: 'center', color: '#333', marginBottom: '20px' }}>調整記録を追加</h2>
      <form onSubmit={handleSubmitAdjustment} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div>
          <label htmlFor="adjustedDate" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>日付:</label>
          <input
            type="date"
            id="adjustedDate"
            value={adjustedDate}
            onChange={(e) => setAdjustedDate(e.target.value)}
            style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
            required
          />
        </div>
        <div>
          <label htmlFor="adjustmentNote" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>調整メモ:</label>
          <textarea
            id="adjustmentNote"
            value={adjustmentNote}
            onChange={(e) => setAdjustmentNote(e.target.value)}
            rows="5"
            style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
            required
          ></textarea>
        </div>
        <div>
          <label htmlFor="adjustmentImage" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>画像:</label>
          <input
            type="file"
            id="adjustmentImage"
            accept="image/*"
            onChange={handleImageChange}
            style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
          />
        </div>
        <button
          type="submit"
          disabled={uploading}
          style={{
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            padding: '12px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '1.1em',
            fontWeight: 'bold',
            opacity: uploading ? 0.7 : 1,
          }}
        >
          {uploading ? 'アップロード中...' : '調整記録を保存'}
        </button>
        {uploadError && <p style={{ color: 'red', textAlign: 'center' }}>{uploadError}</p>}
        {uploadSuccess && <p style={{ color: 'green', textAlign: 'center' }}>{uploadSuccess}</p>}
      </form>
    </div>
  );
};

export default RecipeAdjustmentForm;
